import React, { Component } from 'react';
import Header from '../../components/Header/Header';
import IntroBand from '../../components/IntroBand/IntroBand';
import Footer from '../../components/Footer/Footer';
import SchoolBand from '../../components/SchoolBand/SchoolBand';
import Aux from '../../hoc/Aux/Aux';
import data from '../../data/data';
import Metadata from '../../components/Metadata/Metadata';

class Main extends Component {
  state = {
    mainHeader: {
      headers: data.header["header-colors"],
      images: data.header.images,
      links: data.header.social,
      video: data.header.video,
      introBand: data.header["intro-band"]
    },
    metadata: data.metadata,
    school: data.school,
    footer: data.footer
  };

  render() {
    let randomNumber = (Math.random() * 3).toFixed(0);
    return (
      <Aux>
        <Metadata
          title={this.state.metadata.title}
          description={this.state.metadata.description}
          keywords={this.state.metadata.keywords}
        />
        <Header
          headerColor={this.state.mainHeader.headers[randomNumber].color}
          headerText={this.state.mainHeader.headers[randomNumber].text}
          images={this.state.mainHeader.images}
          social={this.state.mainHeader.links}
          video={this.modalClicked}
          videoContent={this.state.mainHeader.video}
        />
        <IntroBand data={this.state.mainHeader.introBand} />
        <SchoolBand data={this.state.school} />
        <Footer
          reference={this.state.footer.social}
          data={this.state.footer.conditions}
          content={this.state.footer.content}
        />
      </Aux>

    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/containers/Main/Main.js